import { useEffect, useState } from "react";
import * as C from './styles.js';
import { Link, useNavigate } from "react-router-dom";

export default function Others() {

    const navigate = useNavigate();

    const [ showModalSaveOnWatching, setShowModalSaveOnWatching ] = useState();

    useEffect(()=> {

        setShowModalSaveOnWatching(localStorage.getItem('dont_show_again_mark_episode_as_watched'));

    }, []);

    
    function modalSaveWatching(e) {

        if (e == 'ativar') {
            localStorage.removeItem("dont_show_again_mark_episode_as_watched");
        } else {
            localStorage.setItem('dont_show_again_mark_episode_as_watched', true);
        }
        
        setShowModalSaveOnWatching(!showModalSaveOnWatching);
    }

    return(
        <C.Container>
            <C.Header>
                <button onClick={()=>navigate('/configuracoes/principal/')}><i className='fas fa-chevron-left'></i></button>
                <h3>Configurações</h3>
            </C.Header>

            <C.Main>
                <ul>
                    <div className="header-ul-configuracao">
                        <span className="nome-configuracao">Lembrete marcar como assistido</span>
                        <button onClick={()=> !showModalSaveOnWatching ? modalSaveWatching('desativar') : modalSaveWatching('ativar')} className={!showModalSaveOnWatching ? 'bt-ativar-desativar-configuracao bt-desativar-configuracao' : 'bt-ativar-desativar-configuracao bt-ativar-configuracao' }>
                            <div></div>
                        </button>
                    </div>
                    <p className="descricao-configuracao">Ative esta opção para sempre que você sair de um episódio, um pop up de lembrete ser exibido para marcar ou não o episódio como assistido</p>
                </ul>
            </C.Main>
        </C.Container>
    )
}